import { useContext, useEffect } from 'react';

import { GenericContext } from 'shared/constants';

import { GenericContextType } from 'types/generic-context';

export const useSocketSubscribe = (eventName: string, eventHandler: (data: any) => void) => {
  const { socket } = useContext(GenericContext as React.Context<GenericContextType>);

  useEffect(() => {
    socket.on(eventName, eventHandler);

    return () => {
      socket?.off(eventName, eventHandler);
    };
  }, [eventHandler, eventName, socket]);
};
